import { render, staticRenderFns } from "./TriggerDetailsDia.vue?vue&type=template&id=a35f1c70&scoped=true"
import script from "./TriggerDetailsDia.vue?vue&type=script&lang=js"
export * from "./TriggerDetailsDia.vue?vue&type=script&lang=js"
import style0 from "./TriggerDetailsDia.vue?vue&type=style&index=0&id=a35f1c70&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f1c70",
  null
  
)

export default component.exports